import { Injectable } from '@angular/core';
import { SetupItems } from '../models/setupItems';
import { ServiceBase } from './service.base';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService, ResponseObject } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class GlazesService extends ServiceBase {

  constructor(private http: HttpClient,
    authService: AuthService) {
    super(authService);
  }

  public getAllGlazes(artTypeId: string | null): Observable<SetupItems[]> {
    const httpOptions = this.RequestHeaders();
    const api: string = '/Glazes';
    const method: string = '/fetch';
    var url = environment.BASE_API_PATH + api + method;
    if (artTypeId) {
      url += '/' + artTypeId;
    }
    return this.http.get<SetupItems[]>(url, httpOptions);
  }

  public saveGlazes(glazes: SetupItems): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const api: string = '/Glazes';
    const method: string = '/save';
    const url: string = environment.BASE_API_PATH + api + method;
    return this.http.post<ResponseObject>(url, glazes, httpOptions);
  }

  public deleteGlazes(glazesId: string): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const api: string = '/Glazes';
    const method: string = '/deleteGlazes/';
    const url: string = environment.BASE_API_PATH + api + method + glazesId;
    return this.http.delete<ResponseObject>(url, httpOptions);
  }

  public excludeGlaze(Id: string): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
    const api: string = '/Glazes';
    const method: string = '/exclude/';
    const url: string = environment.BASE_API_PATH + api + method + Id;
    return this.http.post<ResponseObject>(url, httpOptions);
  }

}
